import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import TextFieldCardCounter from '../../shared/TextFieldCardCounter';
import { color } from '../../../app/theme';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    input: {
      width: 480,
    },
  },
  {
    name: 'TermsTitle',
  },
);

const TermsTitle = ({ termsTitle, onTermsTitleChange, isSaved }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('ecBinding:termsTitle')}</div>
      <TextFieldCardCounter
        className={classes.input}
        placeholder={t('ecBinding:termsTitle-placeholder')}
        maxCount={12}
        value={termsTitle}
        onChange={onTermsTitleChange}
        status={isSaved && !termsTitle ? 'error' : 'default'}
      />
    </div>
  );
};

export default TermsTitle;
